import type { ReactElement } from 'react';
import type { PackageMediaDto } from '@gr/core/distribution/publishing/dto';
import { useT } from '../../../../app/di';
import { Alert } from '../../../../ui-kit/Alert/Alert';
import { Badge } from '../../../../ui-kit/Badge/Badge';
import { Button, LinkButton } from '../../../../ui-kit/Button/Button';
import { Card } from '../../../../ui-kit/Card/Card';
import { Thumbnail } from '../../../../ui-kit/Thumbnail/Thumbnail';
import styles from './PackageMedia.module.scss';

export interface PackageMediaProps {
  media: readonly PackageMediaDto[];
  zipUrl: string;
  shareFailed: boolean;
  onShare(): void;
}

/** PUB-UC-2: файлы пакета по порядку — поделиться (в галерею телефона), скачать архивом или по одному. */
export function PackageMedia({ media, zipUrl, shareFailed, onShare }: PackageMediaProps): ReactElement {
  const { t } = useT();
  return (
    <Card
      title={t('publishing.package.media')}
      actions={
        media.length > 0 ? (
          <>
            <Button icon="share" onClick={onShare}>
              {t('publishing.package.share')}
            </Button>
            <LinkButton href={zipUrl} icon="download" download>
              {t('publishing.package.zip')}
            </LinkButton>
          </>
        ) : null
      }
    >
      {shareFailed ? <Alert tone="warning">{t('publishing.package.shareFailed')}</Alert> : null}
      {media.length === 0 ? (
        <p className="u-muted">{t('publishing.package.noMedia')}</p>
      ) : (
        <ol className={styles.grid}>
          {media.map((item) => (
            <li key={item.mediaId} className={styles.item}>
              <Thumbnail src={item.thumbnailPath} alt={item.fileName} corner={item.fileName} />
              <div className={styles.footer}>
                {item.usesRendition ? <Badge>{t('publishing.package.rendition')}</Badge> : <span />}
                <LinkButton href={item.downloadPath} size="sm" icon="download" download={item.fileName}>
                  {t('common.download')}
                </LinkButton>
              </div>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}
